// Module
var code = "<div class=\"col-lg-12\" ng-show=\"!vm.initCollapsed\">\r\n    <input id=\"resellerOrderScannerNavigationField\" type=\"text\" class=\"form-control input-sm b-b no-bg text-md\" ng-model=\"vm.scannerInput\" placeholder=\"{{'order.scan' | translate}}\">\r\n</div>\r\n";
// Exports
module.exports = code;